function HeadingPossible() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Text appears to be a heading but is not a heading element.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Heading elements (<code>&lt;h1&gt;-&lt;h6&gt;</code>) provide important document structure, outlines, and navigation functionality to assistive technology users. If heading text is not a true heading, this information and functionality will not be available for that text.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>If the paragraph is a section heading, use a heading element instead (<code>&lt;h1&gt;-&lt;h6&gt;</code>).</p>
    </blockquote>
  )
}

export default HeadingPossible